export default "__VITE_ASSET__66v$_MtV__"